import React, { Component } from 'react';
import { Row, Col, Card, Icon } from 'antd';
import FsdoRegistrationLayout from 'components/layouts/FsdoRegistrationLayout';

export default class FsdoHeader extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div style={{ marginTop: '20px' }}>
                <Row type='flex' justify='center'>
                    <Col span={23} style={{ textAlign: 'center' }}>
                        <Card bodyStyle={{ padding: '8px' }}>
                            <div>
                                <span style={{
                                    color: 'rgb(53, 158, 255)',
                                    fontSize: '16px',
                                    fontWeight: 'bold'
                                }}>
                                    {'FSDO Registration'}
                                </span>
                            </div>
                            <div style={{ marginTop: '0px' }}>
                                <span style={{
                                    fontSize: '10px',
                                    fontStyle: 'italic',
                                    fontWeight: 'bold'
                                }}>
                                    {'On-Line Account Request Form'}
                                </span>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}
